import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { sortBy } from "lodash"
import React, { FC, memo, useMemo, useState } from "react"
import { TaskMemberCostsMember } from "../../../../states/types/task"
import MemberCostRows from "./MemberCostRows"

type Member = TaskMemberCostsMember

type MemberCostTableProps = {
  members: Member[]
  openMemberModalCallback: (member: Member) => void
}

type Order = 'none' | 'asc' | 'desc'
const NEXT_ORDER: Record<Order, Order> = { none: 'asc', asc: 'desc', desc: 'none' }

const MemberCostTable: FC<MemberCostTableProps> = memo(({ members, openMemberModalCallback }) => {
  const [sortOrder, setSortOrder] = useState<Order>('none')

  const updateSortOrderToNext = () => setSortOrder((current) => NEXT_ORDER[current])

  let sortIcon: 'sort' | 'sort-alpha-down' | 'sort-alpha-down-alt' = 'sort'
  if (sortOrder === 'asc') sortIcon = 'sort-alpha-down'
  if (sortOrder === 'desc') sortIcon = 'sort-alpha-down-alt'

  const displayData = useMemo<Member[]>(() => {
    if (sortOrder === 'asc') return sortBy(members, 'kana')
    if (sortOrder === 'desc') return sortBy(members, 'kana').reverse()
    return members
  }, [members, sortOrder])

  return (
    <table className="cost_table">
      <colgroup>
        <col className="col_edit" />
        <col className="col_member" />
        <col className="col_status" />
        <col className="col_period" />
        <col className="col_cost" />
        <col className="col_expand" />
      </colgroup>
      <thead>
        <tr>
          <th>編集</th>
          <th className="row_end member">
            ユーザー
            <FontAwesomeIcon
              icon={['fas', sortIcon]}
              style={{ cursor: "pointer" }}
              onClick={() => updateSortOrderToNext()}
            />
          </th>
          <th className="row_end" colSpan={4}>1時間あたりのコスト</th>
        </tr>
      </thead>
      <tbody>
        {displayData.map((member) => (
          <MemberCostRows
            member={member}
            key={member.id}
            openMemberModalCallback={openMemberModalCallback}
          />
        ))}
      </tbody>
    </table>
  )
})

export default MemberCostTable
